import type { ReactElement } from "react";
import { Icon } from "@chakra-ui/react";
import type { IconProps } from "@chakra-ui/react";

const TwitterLogo = ({
  color = "#1D9BF0",
  ...props
}: IconProps): ReactElement => (
  <Icon viewBox="0 0 128 128" color={color} {...props}>
    <title>Twitter Logo</title>
    <path
      fill="currentColor"
      d="M128 64c0 35.346-28.654 64-64 64-35.346 0-64-28.654-64-64C0 28.654 28.654 0 64 0c35.346 0 64 28.654 64 64z"
    />
    <path
      fill="#fff"
      d="M52.29 97.758c28.378 0 43.897-23.51 43.897-43.897 0-.668-.013-1.333-.044-1.995a31.394 31.394 0 007.697-7.988 30.804 30.804 0 01-8.86 2.428 15.485 15.485 0 006.784-8.534 30.917 30.917 0 01-9.796 3.745 15.413 15.413 0 00-11.263-4.875c-8.52 0-15.43 6.91-15.43 15.428 0 1.21.135 2.388.4 3.517-12.822-.644-24.192-6.784-31.8-16.119a15.372 15.372 0 00-2.09 7.754 15.416 15.416 0 006.865 12.843 15.314 15.314 0 01-6.988-1.93c-.003.064-.003.129-.003.196 0 7.473 5.319 13.711 12.378 15.126a15.395 15.395 0 01-6.967.264c1.963 6.13 7.659 10.59 14.413 10.716a30.957 30.957 0 01-19.162 6.605c-1.246 0-2.473-.072-3.681-.214a43.678 43.678 0 0023.65 6.93z"
    />
  </Icon>
);

export default TwitterLogo;
